export default __webpack_public_path__ + "static/media/terms-of-service-and-privacy.cc7f7362.pdf";